import { type FC } from 'react'
import classNames from 'classnames'

interface HostStateLabelProps {
  tone: 'warning' | 'muted'
  children: string
}

export const HostStateLabel: FC<HostStateLabelProps> = ({ tone, children }) => (
  <span
    className={classNames(
      'd-inline-flex align-items-center zocks-gap-0.5 paragraph-extra-small text-nowrap',
      tone === 'warning' ? 'zocks-text-gray-900' : 'zocks-text-gray-600',
    )}
  >
    {tone === 'warning' ? <i className='bi bi-exclamation-triangle-fill zocks-text-warning-dark' aria-hidden='true' /> : null}
    {children}
  </span>
)
